import moment from 'moment';
import { TreatmentEntity } from '../interfaces/treatment-entity';


export class VisitItem {
    public ID: number;
    public BranchID: number;
    public BranchName: string;
    public BusinessName: string;
    public CustomerID: number;
    public CustomerName: string;
    public Duration: number;
    // public EventReasonID: number;
    // public EventReasonName: string;
    public ReadOnly: boolean;
    public SchedulerID: number;
    public SchedulerName: string;
    public StartAt: moment.Moment;
    public TherapistPracticeID: number;
    public Treatments?: TreatmentEntity[];
    public CanBeBooked: boolean;
    public Arrived?: boolean;
    public ExpendDetails: boolean;
    public even: boolean; // to style row in grid

    constructor(obj?: any) {

        this.ID = obj ? obj.ID : null;
        this.BranchID = obj ? obj.BranchID : null;
        this.BranchName = obj ? obj.BranchName : null;
        this.BusinessName = obj ? obj.BusinessName : null;
        this.CustomerID = obj ? obj.CustomerID : null;
        this.CustomerName = obj ? obj.CustomerName : null;
        this.Duration = obj ? obj.Duration : null;
        // this.EventReasonID = obj ? obj.EventReasonID : null;
        // this.EventReasonName = obj ? obj.IEventReasonName : null;
        this.ReadOnly = obj ? obj.ReadOnly : null;
        this.SchedulerID = obj ? obj.SchedulerID : null;
        this.SchedulerName = obj ? obj.SchedulerName : null;
        this.StartAt = obj && obj.StartAt ? moment(obj.StartAt) : null;
        this.TherapistPracticeID = obj ? obj.TherapistPracticeID : null;
        this.Treatments = obj && obj.Treatments || null;
        this.CanBeBooked = obj && obj.CanBeBooked || false;
        this.Arrived = obj && obj.Arrived || null; // true = arrived, false = NoShow, null = notSet

        this.ExpendDetails = obj && obj.ExpendDetails || false;
        this.even = obj && obj.event || false;
    }

    // get EventReasonName(): string {
    //     return Utils.generateVisitReasonSummary1(this.Treatments, this.translate);
    // }
}